const PERMISSION_KEY= "personalize:nebula_positions";
const PAGE_URL = {
    NEBULA_POSITIONS_PAGE: "/admin/personalize/nebula-positions"
}

export {PERMISSION_KEY, PAGE_URL}

